import { FunctionField, SelectField, useTranslate } from 'react-admin';
import { Box } from '@mui/material';
import { transactionStatusChoices } from '@/components/global/options/selectOptions.jsx';
import StatusIconWithTooltip from '@/components/transaction/StatusIconWithTooltip.jsx';

const TransactionStatusField = ({ source = 'status' }) => {
    const translate = useTranslate();
    return (
        <FunctionField
            source={source}
            render={record => {
                let status = transactionStatusChoices(translate).find(s => s.id === record.status);
                return (
                    <Box display='flex' alignItems='center'>
                        <StatusIconWithTooltip icon={status.icon} tooltipContent={record.transactionStatusInfo} />
                        <SelectField
                            source='status'
                            choices={transactionStatusChoices(translate).map(choice => ({ id: choice.id, name: choice.name }))}
                            variant='h6'
                        />
                    </Box>
                );
            }}
        />
    );
};

export default TransactionStatusField;
